import styled from 'styled-components';

export const LogoWrapper = styled.div`
  filter: drop-shadow(0px 1px 3px rgba(16, 24, 40, 0.1))
    drop-shadow(0px 1px 2px rgba(16, 24, 40, 0.06));
  width: 48px;
  height: 48px;
`;
